@if (!isLoading) {
<div class="card">
  <div class="card-header">
    Instructions
  </div>
  <div class="card-body">

    <div class="mb-3">
      <strong>Page Url</strong><br />
      <div>
        <a [attr.href]="url" target="_blank" name="url" rel="noreferrer">{{ url }}</a>
      </div>
    </div>

    <div class="mb-3">
      <strong>Keywords</strong>
      <ul class="list-unstyled">
        @for (keywordPhrase of keywordPhrases; track keywordPhrase)
        {
        <li>
          <a [attr.href]="googleSearchUrl + 'search?pws=0&q=' + keywordPhrase.trim()" target="_blank"
            name="keywordPhrase" rel="noreferrer">{{ keywordPhrase }}</a>
        </li>
        }
      </ul>
    </div>

    @if (pageType) {
    <div class="mb-3">
      <strong>Page Type</strong>
      <div>{{ pageType }}</div>
    </div>
    }

    @if (showNotesForContentWriter) {
    <div class="mb-3">
      <strong>Notes for Content Writer</strong>
      <div>{{ notesForContentWriter }}</div>
    </div>
    }

    <div class="mb-3">
      <strong>Notes for Implementation Specialist</strong>
      <div>{{ notesForImplementationSpecialist }}</div>
    </div>
  </div>
</div>
}